import { svg } from '../../utils/actions.assets';

/**
 * Dropdown Group Control Template
 * @param $select array options DOM
 * @returns string
 */
export default ($select: JQuery): string => {
  const dropdownDescription = $select.attr('description') || '';
  const $optgroup = $select.find('optgroup');
  let html = '';
  if ($optgroup.length) {
    $optgroup.each(function () {
      const optgroupLabel = jQuery(this).attr('label') || '';
      const optgroupDescription = jQuery(this).attr('description') || '';
      const $option = jQuery(this).find('option');

      let optionHtml = '';
      $option.each(function () {
        const value = jQuery(this).attr('value') || '';
        const text = jQuery(this).text() || '';
        const description = jQuery(this).attr('description') || '';
        optionHtml += `<li class="option-item" data-value="${value}" data-description="${description}">${text}</li>`;
      });

      html += `<div class="optgroup-wrap">
        <div class="optgroup-label" data-description="${optgroupDescription}">
          ${optgroupLabel}
          ${svg('chevronDown')}
        </div>
        <ul>
          ${optionHtml}
        </ul>
      </div>`;
    });
  }

  const template = `<div class="dropdown-group-wrap"><div class="dropdown-group" data-description="${dropdownDescription}">${html}<div class="dropdown-description">${dropdownDescription}</div></div></div>`;

  return template;
};

/**
 * templateSimpleDropdown
 * @param $select array options DOM
 * @returns string
 */
export const templateSimpleDropdown = ($select: JQuery): string => {
  const $childs = $select.children();
  let html = '';
  if ($childs.length) {
    let optionHtml = '';
    $childs.each(function () {
      const value = jQuery(this).attr('value') || '';
      const content = jQuery(this).html() || '';
      const icon = jQuery(this).attr('data-icon') || '';
      optionHtml += `<li class="option-item" data-value="${value}" >${icon ? svg(icon) : ''}${content}</li>`;
    });
    html += `<ul>
          ${optionHtml}
        </ul>`;
  }

  const template = `<div class="dropdown-group-wrap dropdown-simple"><div class="dropdown-group">${html}</div></div>`;

  return template;
};
